
import {
  defineComponent, onMounted, ref, watch, computed, onUnmounted,
} from 'vue';
// import caronMap from './components/caronMap.vue';
import {
  Table, ConfigProvider, message, Modal,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import EditPop from './editPop.vue';

import store from '@/store';

export default defineComponent({
  components: {
    ConfigProvider,
    Table,
    EditPop,
    Modal,
  },
  setup (props,{ emit, }) {
    // 列表行配置
    const columns = [
      {
        title: '序号',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
        slots: { customRender: 'index', },
        width: '5%',
      },
      {
        title: '年份',
        align: 'center',
        dataIndex: 'year',
        key: 'year',
        customRender: (data:any) => `${data.text ?? ''}年`,
        width: '9%',
      },
      {
        title: '优良天（天）',
        align: 'center',
        dataIndex: 'fineDays',
        key: 'fineDays',
        slots: { customRender: 'biggerGreen', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: 'PM₂․₅(μg/m³)',
        align: 'center',
        dataIndex: 'pm25',
        key: 'pm25',
        slots: { customRender: 'biggerGreen', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: 'PM₁₀(μg/m³)',
        align: 'center',
        dataIndex: 'pm10',
        key: 'pm10',
        slots: { customRender: 'biggerRed', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: 'SO₂(μg/m³)',
        align: 'center',
        dataIndex: 'so2',
        key: 'so2',
        slots: { customRender: 'biggerRed', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: 'NO₂(μg/m³)',
        align: 'center',
        dataIndex: 'no2',
        key: 'no2',
        slots: { customRender: 'biggerRed', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: 'O₃(μg/m³)',
        align: 'center',
        dataIndex: 'o3',
        key: 'o3',
        slots: { customRender: 'biggerRed', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: 'CO(mg/m³)',
        align: 'center',
        dataIndex: 'co',
        key: 'co',
        slots: { customRender: 'biggerRed', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: '综合指数',
        align: 'center',
        dataIndex: 'composite_index',
        key: 'composite_index',
        slots: { customRender: 'biggerRed', },
        width: '9%',
        ellipsis: true,
      },
      {
        title: '操作',
        align: 'center',
        key: 'op',
        slots: { customRender: 'op', },
        width: '14%',
        ellipsis: true,
      },
    ];
    // 表格数据
    const tableData = ref<any>([]);
    // 列表数据
    const annualList = computed(() => store.state.target.annualList);

    // 分页
    const current = ref<number>(1);
    const total = ref<number>(0);
    const curPageSize = ref<number>(10);

    // 单行信息
    const itemInfo = ref<any>({});
    // 记录弹窗显隐
    const modalVisible = ref<boolean>(false);
    // 弹窗类型 1:新建，2编辑，3详情
    const popType = ref<number>(1);

    const toCurPage = () => {
      emit('isShow',true);
    };

    // 加载表格数据
    const loadUserTable = (pageNo = 1,pageSize = 10): void => {
      const params =
    {
      pageNo,
      pageSize,
    };

      store.dispatch('target/getAnnualTable', params);
    };
    // 表格变化回调
    const handleChange = (page: any, pageSize: any) => {
      current.value = page;
      loadUserTable(page, pageSize);
    };
    // 显示页数变化回调
    const sizeChange = (cur:any,size:any) => {
      current.value = cur;
      curPageSize.value = size;

      loadUserTable(cur, size);
    };

    // 点击新增
    const handleNew = (): void => {
      popType.value = 1;
      itemInfo.value = {};
      modalVisible.value = true;
    };
    // 点击编辑
    const handleEdit = (item: any): void => {
      itemInfo.value = item;
      popType.value = 2;
      modalVisible.value = true;
    };
    // 点击详情
    const handleDetail = (item: any): void => {
      itemInfo.value = item;
      popType.value = 3;
      modalVisible.value = true;
    };
    // 点击删除
    const handleDelete = (id: any): void => {
      const param = {
        id,
      };

      store.dispatch('target/deleteAnnualData', param).then(() => {
        loadUserTable(current.value , curPageSize.value);
      });
    };
    // 取消弹窗
    const cancel = (): void => {
      modalVisible.value = false;
      itemInfo.value = {};
    };
    // 保存弹窗
    const save = (): void => {
      modalVisible.value = false;
      itemInfo.value = {};
      loadUserTable(current.value, curPageSize.value);
    };

    watch(annualList, (val) => {
      tableData.value = val.list;
      total.value = val.total;
    },{
      deep: true,
    });

    onMounted(() => {
      loadUserTable();
    });
    onUnmounted(() => {
      store.commit('target/setStateItem', { value: {}, type: 'annualList', });
    });

    return {
      zhCN,
      columns,
      tableData,
      total,
      current,
      curPageSize,
      modalVisible,
      itemInfo,
      popType,
      handleChange,
      sizeChange,
      toCurPage,
      handleNew,
      handleEdit,
      handleDelete,
      handleDetail,
      cancel,
      save,
    };
  },
});
